import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Failed' },
    { value: 2, label: 'Pending' },
    { value: 3, label: 'Processing' },
    { value: 4, label: 'Complete' },
  ],
});
